import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadAllCredits } from '../services/api';
import Loader from '../utils/Loader';

const CreditsContext = createContext(null);

export const useCredits = () => {
  const ctx = useContext(CreditsContext);
  if (!ctx) throw new Error("useCredits must be used within a CreditsProvider");
  return ctx;
};

function CheckCredits({ children }) {
  const [hasCredits, setHasCredits] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkCredits();
  }, []);

  const checkCredits = async () => {
    try {
      setLoading(true);
      const response = await loadAllCredits();
      
      if (response.status === 'success') {
        setHasCredits(true);
      } else {
        setHasCredits(false);
      }
    } catch (error) {
      console.error('Error checking credits:', error);
      setHasCredits(false);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestCredits = () => {
    navigate('/account');
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Loader size="large" text="Checking credits..." />
      </div>
    );
  }

  if (!hasCredits) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100vh',
        padding: '4rem 2rem 2rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '500px',
          padding: '2rem',
          borderRadius: '8px',
          backgroundColor: 'var(--card-bg, #f8f9fa)',
          border: '1px solid var(--border-color, #e9ecef)',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ 
            marginBottom: '1rem', 
            color: 'var(--text-primary, #333)',
            fontSize: '1.5rem'
          }}>
            No Credits Available
          </h2>
          <p style={{ 
            marginBottom: '1.5rem', 
            color: 'var(--text-secondary, #666)',
            lineHeight: '1.5'
          }}>
            You don't have any credits to access this feature. Please request credits to continue.
          </p>
          <button
            onClick={handleRequestCredits}
            style={{
              backgroundColor: 'var(--primary-color, #007bff)',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = 'var(--primary-hover, #0056b3)'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'var(--primary-color, #007bff)'}
          >
            Go to Account
          </button>
        </div>
      </div>
    );
  }

  return (
    <CreditsContext.Provider value={{ hasCredits, checkCredits }}>
      {children}
    </CreditsContext.Provider>
  );
}

export default CheckCredits;
